<template>
  <div class="form-select">
    <div class="text-container">
      <div :class="isSubItem ? 's-title' : 'title'">
        {{ title }} <span v-show="required">*</span>
      </div>
      <div class="subtitle">{{ subtitle }}</div>
    </div>
    <Select
      :disabled="disabled"
      :placeholder="placeholder"
      :isShowErrorMessage="isShowErrorMessage"
      :errorMessage="errorMessage"
      :helpText="helpText"
      :onBlur="onBlur"
      :onChange="onChange"
      :modelValue="modelValue"
      :data="data"
      @update:modelValue="(value) => $emit('update:modelValue', value)"
    >
      <template #help-text>
        {{ helpText }}
        <span class="guide-text">{{ guideText }}</span>
        <slot name="help-text"> </slot>
      </template>
    </Select>
  </div>
</template>

<script>
import Select from "@/components/atom/Select.vue";
export default {
  components: {
    Select,
  },
  emits: ["update:modelValue"],
  props: {
    disabled: {
      default: false,
      type: Boolean,
    },
    placeholder: {
      default: "",
      type: String,
    },
    isShowErrorMessage: {
      default: false,
      type: Boolean,
    },
    errorMessage: {
      default: "",
      type: String,
    },
    modelValue: {
      type: String,
      default: "",
    },
    data: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
    helpText: {
      type: String,
      default: "",
    },
    logoSrc: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
    isSubItem: {
      type: Boolean,
      default: false,
    },
    onBlur: {
      type: Function,
      default: () => {},
    },
    onChange: {
      type: Function,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped>
.text-container {
  margin-bottom: $space/2;
  .s-title {
    color: $grey-1000;
    font-size: $base-font-size;
    font-weight: 400;
  }
  .title {
    color: $grey-1000;
    font-size: $base-font-size;
    font-weight: 700;
  }
  .subtitle {
    font-size: $base-font-size - 2px;
  }
  span {
    color: $danger;
  }
}
.guide-text {
  font-weight: 700;
}
</style>
